import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AppLayout from "@/components/layout/AppLayout";
import LoginPage from "@/pages/auth/LoginPage";
import ForgotPasswordPage from "@/pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/auth/ResetPasswordPage";
import AcceptInvitePage from "@/pages/auth/AcceptInvitePage";
import DashboardPage from "@/pages/DashboardPage";
import InventoryPage from "@/pages/InventoryPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import MovementsPage from "@/pages/MovementsPage";
import ShoppingPage from "@/pages/ShoppingPage";
import TasksPage from "@/pages/TasksPage";
import EventsPage from "@/pages/EventsPage";
import EventDetailPage from "@/pages/EventDetailPage";
import RoomsPage from "@/pages/RoomsPage";
import CalendarPage from "@/pages/CalendarPage";
import NotificationsPage from "@/pages/NotificationsPage";
import ReportsPage from "@/pages/ReportsPage";
import MembersPage from "@/pages/MembersPage";
import SettingsPage from "@/pages/SettingsPage";
import AuditPage from "@/pages/AuditPage";
import ProfilePage from "@/pages/ProfilePage";
import PlatformPage from "@/pages/PlatformPage";
import InvoicesPage from "@/pages/InvoicesPage";
import ReimbursementsPage from "@/pages/ReimbursementsPage";
import PublicBookingPage from "@/pages/PublicBookingPage";
import LegalPage from "@/pages/LegalPage";
import DocumentsPage from "@/pages/DocumentsPage";
import StatsPage from "@/pages/StatsPage";
import MinutesPage from "@/pages/MinutesPage";
import MinuteDetailPage from "@/pages/MinuteDetailPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/password-dimenticata" element={<ForgotPasswordPage />} />
          <Route path="/reimposta-password/:token" element={<ResetPasswordPage />} />
          <Route path="/invito/:token" element={<AcceptInvitePage />} />
          <Route path="/piattaforma" element={<PlatformPage />} />
          <Route path="/prenota/:slug" element={<PublicBookingPage />} />
          <Route path="/note-legali" element={<LegalPage />} />
          <Route element={<AppLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/inventario" element={<InventoryPage />} />
            <Route path="/inventario/:id" element={<ProductDetailPage />} />
            <Route path="/movimenti" element={<MovementsPage />} />
            <Route path="/spesa" element={<ShoppingPage />} />
            <Route path="/compiti" element={<TasksPage />} />
            <Route path="/eventi" element={<EventsPage />} />
            <Route path="/eventi/:id" element={<EventDetailPage />} />
            <Route path="/sale" element={<RoomsPage />} />
            <Route path="/calendario" element={<CalendarPage />} />
            <Route path="/notifiche" element={<NotificationsPage />} />
            <Route path="/report" element={<ReportsPage />} />
            <Route path="/fatture" element={<InvoicesPage />} />
            <Route path="/rimborsi" element={<ReimbursementsPage />} />
            <Route path="/documenti" element={<DocumentsPage />} />
            <Route path="/statistiche" element={<StatsPage />} />
            <Route path="/verbali" element={<MinutesPage />} />
            <Route path="/verbali/:id" element={<MinuteDetailPage />} />
            <Route path="/membri" element={<MembersPage />} />
            <Route path="/impostazioni" element={<SettingsPage />} />
            <Route path="/registro" element={<AuditPage />} />
            <Route path="/profilo" element={<ProfilePage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
